import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  REQUEST_PRIZE_WINNERS: null,
  RECEIVED_WINNER_HISTORY: null,
  EXPAND_ROW: null,
  COLLAPSE_ROW: null
});

export const requestPrizeWinnersAction = prizeId => ({
  type: Types.REQUEST_PRIZE_WINNERS,
  prizeId
});

export const receivedWinnerHistoryAction = (winnerUserId, prizeHistory) => ({
  type: Types.RECEIVED_WINNER_HISTORY,
  winnerUserId,
  prizeHistory
});

export const expandRow = row => ({
  type: Types.EXPAND_ROW,
  row
});

export const collapseRow = () => ({
  type: Types.COLLAPSE_ROW
});



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/actions.js